import { SModel } from "servisofts-model";
import Action from "./Action";
import Reducer from "./Reducer";

export default new SModel<Action, Reducer>({
    info: {
        component: "sucursal_paquete_venta_usuario"
    },
    Columns: {
        "key": { type: "text", pk: true },
        "fecha_on": { type: "timestamp", label: "Fecha de registro" },
        "key_usuario": { type: "text", fk: "usuario" },
        "estado": { type: "integer" },
        "key_sucursal": { type: "text", fk: "sucursal" },
        "key_paquete_venta_usuario": { type: "text", fk: "paquete_venta_usuario" },
    },
    Action,
    Reducer,
});